import React from 'react'
import portfolio from "../../../assets/portfolio2.jpg"
import "./Home.scss"
import { motion } from 'framer-motion'
import TypeWriterEffect from 'react-typewriter-effect';

const Home = () => {
  const moveVariants = {
    animation: {
      y: [0, -15],
      transition: {
        yoyo: Infinity,
        duration: 2,
        delay: 1
      }

    }
  }


  return (
    <motion.div className="container " id='home'
      initial={{ y: -15, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={
        {
          duration: 2,
          delay: 0.5
        }
      }
    >
      <div className="profile">
        <img src={portfolio} alt="portfolio" />
      </div>
      <div className="profile_text">
        <h3 className='name'>Hi, I'm <span>Vihaan Shah</span> </h3>
        <span className='job'>Web Developer Based in Princeton</span>
        <span className='text'> Coding to solve, creating to innovate.
          <br /> Bringing ideas to life, 
          <br />one line at a time.
          </span>
        <motion.a
          href="#contact"
          whileHover={{ scale: 1.1 }}
          variants={moveVariants}
          animate="animation"
        >
          connect with me</motion.a>
        <div
          className="web"

        >
          Full Stack Developer
        </div>
        <div
          className="ui"
        >
          UI/UX Designer
        </div>
        <div
          className="freelance"
        >
          Solutions Architect
        </div>
      </div>
    </motion.div>
  )
}

export default Home